// WARNING: This file cannot import anything from the codebase
// It must stay as standalone as possible to prevent loading a tree of dependencies
// from the microsite, causing the build to behave erractically on setup
import { writable, type Writable } from "svelte/store";

const WAITING_CHECK_INTERVAL = 2000;

export type BuildContextStore = {
  poller: {
    getDelay: (delay?: number) => number;
  },
  apiUtils: {
    handleError: (error: unknown, options: { skipAllErrorHandling?: boolean }) => never;
    getPersistedJwt: () => string | null;
  },
  statusHandler: {
    resetSurvey: () => void;
  }
};

export const setPollerUtils = (poller: BuildContextStore["poller"]) => {
  buildContextStore.update((store) => {
    store.poller = poller;
    return store;
  });
};

export const setApiUtils = (apiUtils: BuildContextStore["apiUtils"]) => {
  buildContextStore.update((store) => {
    store.apiUtils = apiUtils;
    return store;
  });
};

export const setStatusHandler = (statusHandler: BuildContextStore["statusHandler"]) => {
  buildContextStore.update((store) => {
    store.statusHandler = statusHandler;
    return store;
  });
};

export const resetBuildContext = (store: Writable<BuildContextStore> = buildContextStore) => {
  // These are defaults for the public library. They get replaced via main > setup() when running the microsite.
  store.set({
    poller: {
      getDelay: (delay?: number) => delay ?? WAITING_CHECK_INTERVAL
    },
    apiUtils: {
      handleError: (error: unknown) => { throw error; },
      getPersistedJwt: () => sessionStorage.getItem("jwt")
    },
    statusHandler: {
      resetSurvey: () => {}
    }
  });
};

export function initStore() {
  const store = writable<BuildContextStore>();
  resetBuildContext(store);
  return store;
}

export const buildContextStore = initStore();
